





































































































































































import {Component, Vue} from 'vue-property-decorator';
import {loginService} from '@/services/login.service';
import {HomeIcon, UserIcon, KeyIcon} from 'vue-feather-icons';
import {AuthPhoneDto, BizSirenEncodeResponse, BizSirenResultDto} from '@/services/LoginModels';

declare global {
  interface Window {
    recvSirenPhoneResult: any;
  }
}

@Component({
  components: {
    HomeIcon,
    UserIcon,
    KeyIcon,
  },
})
export default class AuthSignupPhone extends Vue {
  private host = window.location.protocol + '//' + window.location.host;
  private reqInfo = '';
  private windowRef: any = null;
  authPhoneDto: AuthPhoneDto = {
    name: '',
    birthDay: '',
    juminNumber2: '',
    phoneType: 'skt',
    phoneNumber1: '',
    phoneNumber2: '',
    phoneNumber3: '',
    authKey: '',
  };

  mounted(): void {
    // eslint-disable-next-line
    window.recvSirenPhoneResult = this.recvSirenPhoneResult;
  }

  cancel(): void {
    this.$router.go(-1);
  }

  onAuthPhoneSubmit(): void {
    console.log('auth attempt');
    console.log(this.authPhoneDto);

    //인증번호 요청
    const retUrl = this.host + '/noHeader/p/bizSirenCallBackPhone';
    loginService.getBizSirenEncode(retUrl).then(response => {
      if (response.status == 200) {
        const responseData = response.data as BizSirenEncodeResponse;
        this.reqInfo = responseData.reqInfo;
        this.windowRef = window.open(
          '',
          '',
          'width=430, height=560, resizable=1, scrollbars=no, status=0, titlebar=0, toolbar=0, left=300, top=200',
        );
        const popupDocument = this.windowRef.document;
        const frm = popupDocument.createElement('form');
        frm.setAttribute('id', 'auth-form');
        frm.setAttribute('action', 'https://pcc.siren24.com/pcc_V3/jsp/pcc_V3_j10_v4.jsp');
        frm.setAttribute('method', 'post');
        frm.setAttribute('target', '_self');

        const element1 = popupDocument.createElement('input');
        element1.type = 'hidden';
        element1.value = responseData.cryptoTokenId;
        element1.name = 'crypto_token_id';
        frm.appendChild(element1);

        const element2 = popupDocument.createElement('input');
        element2.type = 'hidden';
        element2.value = responseData.integrityValue;
        element2.name = 'integrity_value';
        frm.appendChild(element2);

        const element3 = popupDocument.createElement('input');
        element3.type = 'hidden';
        element3.value = responseData.reqInfo;
        element3.name = 'reqInfo';
        frm.appendChild(element3);

        const element4 = popupDocument.createElement('input');
        element4.type = 'hidden';
        element4.value = responseData.verSion;
        element4.name = 'verSion';
        frm.appendChild(element4);

        popupDocument.body.appendChild(frm);
        frm.submit();
      } else {
        //http response 오류 처리
      }
    });

    //this.$router.push('/p/AuthSignupTerm');
    // if (this.authPhoneDto.name == '') {
    // 	console.log('이름을 입력해주세요');
    // 	return;
    // }
    // if (this.authPhoneDto.birthDay == '') {
    // 	console.log('생일을 입력해주세요');
    // 	return;
    // }
    // if (this.authPhoneDto.juminNumber2 == '') {
    // 	console.log('성별을 입력해주세요');
    // 	return;
    // }
    // if (
    // 	this.authPhoneDto.phoneNumber1 == '' ||
    // 	this.authPhoneDto.phoneNumber2 == '' ||
    // 	this.authPhoneDto.phoneNumber3 == ''
    // ) {
    // 	console.log('휴대폰번호를 입력해주세요');
    // 	return;
    // }

    //인증번호 요청
    // loginService.login(this.authPhoneDto).then(response => {
    //   if (response.status == 200) {
    //     const responseData = response.data;
    //     if (responseData.resultCode == '0000') {
    //       sessionStorage.setItem('user', JSON.stringify(responseData.obj));
    //       //로그인 성공 mypage로 이동
    //       console.log('로그인 성공 mypage로 이동');
    //     } else {
    //       //PMS 로그인 에러처리 필요
    //       console.log('로그인 실패:' + responseData.msg);
    //     }
    //   } else {
    //     //http response 오류 처리
    //   }
    // });
    //인증번호 컨트롤 표시
  }

  recvSirenPhoneResult(type: string, result: BizSirenResultDto): void {
    console.log(type, result);
    this.$router.push('/p/AuthSignupTerm');
  }
}
